import { useState, useContext } from "react"
import { CredentialsContext } from "../../../API/CredentialsContext"
import { v4 as uuidv4 } from "uuid"
import { Actions } from "../../../Reducer/reducer"
import Table from "./Table"
import FormFieldWrapper from "../../../Common/FormFieldWrapper"
import { PrimarySubmitButton } from "../../../Common/Button"

const ChangeTransporter = () => {
    const [ctState, setCtState] = useState({
        credential: {},
        ewaybillNo: "",
        newTransporterId: ""
    })
    const [requests, setRequests] = useState([])
    const { state, dispatch } = useContext(CredentialsContext)
    const users = state?.credentials || []
    const isChangeTransporterButtonDisabled =
        Object.keys(ctState.credential).length === 0 ||
        ctState.ewaybillNo === "" ||
        ctState.newTransporterId === "" ||
        state.loading

    const handleState = (event) => {
        const { name, value } = event.target
        if (name === 'credential') {
            setCtState(prev => (
                {
                    ...prev,
                    [name]: users.find(u => u.id === +value)
                }
            ))
        } else {
            setCtState(prev => (
                {
                    ...prev,
                    [name]: value
                }
            ))
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleChangeTransporter(event)
        }
    }

    const handleChangeTransporter = async (event) => {
        event.preventDefault()
        try {
            dispatch({ type: Actions.ShowLoading })
            const payload = {
                ewaybillNos: ctState.ewaybillNo.split("\n"),
                newTransporterId: ctState.newTransporterId,
                credentials: {
                    userName: ctState.credential.userName,
                    password: ctState.credential.password,
                    gstNumber: ctState.credential.gstNumber,
                    loginType: "TR"
                }
            }
            const requestId = uuidv4().replaceAll("-", "").substring(0, 5)
            const response = await fetch('https://dev-api.e-waybill.in/api/e-waybill/change?sync=true',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ ...payload, requestId })
                })
            if (response.ok) {
                const data = await response.json()
                setRequests([{ requestId, status: data.status, response: data, request: payload }])
            }
        }
        catch (error) { console.error('Error in changing transporter id:', error) }
        finally { dispatch({ type: Actions.HideLoading }) }
    }

    return (
        <form className="py-2" onSubmit={handleChangeTransporter}>
            <div className="row">
                <div className="col-lg-3 m-3">
                    <h4>Change Transporter</h4>
                    <FormFieldWrapper>
                        <label htmlFor='credential' className="mb-2">Credential</label>
                        <select className="form-select" onChange={handleState} name="credential" id='credential'>
                            <option>Select</option>
                            {
                                users.map((user, index) => {
                                    return (
                                        <option key={index} value={user.id}>{user.gstNumber}</option>
                                    )
                                })
                            }
                        </select>
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <textarea
                            className="form-control"
                            style={{ height: "200px" }}
                            type="text"
                            name="ewaybillNo"
                            id="ewaybillNo"
                            placeholder="Enter EWaybill one per line"
                            onChange={handleState} />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <label htmlFor='newTransporterId' className="mb-2">New Transporter ID</label>
                        <input
                            className="form-control"
                            type="text"
                            name="newTransporterId"
                            id="newTransporterId"
                            placeholder="New Transporter ID"
                            onChange={handleState}
                            onKeyDown={handleKeyDown}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <PrimarySubmitButton
                            disabled={isChangeTransporterButtonDisabled}
                        >
                            Change Transporter
                        </PrimarySubmitButton>
                    </FormFieldWrapper>
                </div>
                <div className="col-lg-7 m-5">
                    <div className="overflow-x-auto mb-3">
                        <Table requests={requests} />
                    </div>
                </div>
            </div >
        </form >
    )
}
export default ChangeTransporter